import classNames from "classnames";
import { Form } from "react-bootstrap";

const FormGroup = ({ children, className, horizontal, ...rest }) => {
    if (horizontal === true) {
        return <div className={classNames('row align-items-center', className)} {...rest}>
            {children}
        </div>
    }
    return <Form.Group className={classNames(className)} {...rest}>
        {children}
    </Form.Group>
}

export default FormGroup;